import getIndent from '../utils/getIndent';
/**
 * User pressed Enter in an editor:
 * Insert a new code line and start it with the indentation from previous line
 */

function onEnter(event, editor, next) {
  var value = editor.value;

  if (!value.selection.isCollapsed) {
    return next();
  }

  event.preventDefault();
  var startBlock = value.startBlock;
  var currentLineText = startBlock.text;
  var indent = getIndent(currentLineText, '');
  return editor.splitBlock().insertText(indent).focus();
}

export default onEnter;